function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (window.innerWidth < 990) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    
    this.bindedHandleResize = this.handleResize.bind(this);
    this.bindedHandleMobileSubmit = function(event){
      if (this.isMobile) {
        event.currentTarget.classList.add('loading');
        this.handleSubmit(event);
      }
    }.bind(this);
    this.bindedHandleDesktopSubmit = debounce((event) => {
      if (!this.isMobile) {
        this.handleSubmit(event);
      }
    }, 800).bind(this);

    this.querySelector('form').addEventListener('input', this.bindedHandleDesktopSubmit);
    this.querySelector('button.facets__apply').addEventListener('click', this.bindedHandleMobileSubmit);
    this.querySelectorAll('input[type="checkbox"]')?.forEach((ele) => {
      ele.addEventListener('click', this.handleClick);
    });
    window.addEventListener('popstate', this.handleHistoryChange);

    this.mql = window.matchMedia('(min-width: 990px)');
    this.mql.addEventListener("change", this.bindedHandleResize);
  }

  disconnectedCallback() {
    this.querySelector('form').removeEventListener('input', this.bindedHandleDesktopSubmit);
    this.querySelector('button.facets__apply').removeEventListener('click', this.bindedHandleMobileSubmit);
    this.querySelectorAll('input[type="checkbox"]')?.forEach((ele) => {
      ele.removeEventListener('click', this.handleClick);
    });
    window.removeEventListener('popstate', this.handleHistoryChange);
    this.mql.removeEventListener("change", this.bindedHandleResize);
  }

  static renderPage(searchParams, event, updateURLHash = true, updateFilters = false) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const url = `${window.location.pathname}?section_id=${document.getElementById('collection').dataset.id}&${searchParams}`;
    const filterDataUrl = (element) => element.url === url;

    FacetFiltersForm.filterData.some(filterDataUrl)
      ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, updateFilters)
      : FacetFiltersForm.renderSectionFromFetch(url, event, updateFilters);

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, updateFilters) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderCollectionGrid(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderMobileNav(html);
        
        if (updateFilters) FacetFiltersForm.renderFilters(html, event);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, updateFilters) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderCollectionGrid(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderMobileNav(html);

    if (updateFilters) FacetFiltersForm.renderFilters(html, event);
  }

  static renderFilters(html) {
    document.getElementById('facets').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('facets').innerHTML;
  }

  static renderCollectionGrid(html) {
    document.getElementById('collection-grid').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('collection-grid').innerHTML;
    document.getElementById('collection-grid').applySize();
  }

  static renderProductCount(html) {
    document.getElementById('collection-heading').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('collection-heading').innerHTML;
  }

  static renderMobileNav(html) {
    document.getElementById('collection-facets-mobile-nav').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('collection-facets-mobile-nav').innerHTML;
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  handleSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  handleSubmit(event) {
    event.preventDefault();

    document.getElementById('collection-grid').transitionEnded = false;
    document.getElementById('collection-grid').submitEnded = false;
    document.getElementById('collection-grid').classList.add('loading');

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    sortFilterForms.forEach((form) => {
      if (form.id === 'FacetFiltersForm' || form.id === 'FacetSortForm') {
        if (form.querySelector("input:checked")?.value) {
          const formData = new FormData(form);
          const searchParams = new URLSearchParams(formData).toString();
          forms.push(searchParams);
        }
      }
    });

    this.handleSubmitForm(forms.join('&'), event);
  }

  handleClick(event) {
    if (event.currentTarget.value == "") {
      if (event.currentTarget.checked) {
        event.currentTarget.closest('.facets__list').querySelectorAll('input:not([value=""])').forEach((ele) => {
          ele.checked = false;
        });
      }
    } else {
      if (event.currentTarget.checked) {
        event.currentTarget.closest('.facets__list').querySelector('input[value=""]').checked = false;
      }
    }
  }

  handleHistoryChange = (event) => {
    const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
    if (searchParams === FacetFiltersForm.searchParamsPrev) return;
    FacetFiltersForm.renderPage(searchParams, null, false, true);
  }

  handleResize = (event) => {
    if (event.matches) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);

class FacetsDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bindedHandleNavClick = this.handleNavClick.bind(this);

    this.querySelectorAll('.facets__mobile-nav-item').forEach((ele) => {
      ele.addEventListener('click', this.bindedHandleNavClick);
    })
  }

  disconnectedCallback() {
    this.querySelectorAll('.facets__mobile-nav-item').forEach((ele) => {
      ele.removeEventListener('click', this.bindedHandleNavClick);
    })
  }

  handleNavClick(event) {
    let facetsEle;
    let otherFacetsEle;
    if (event.currentTarget.dataset.id == 'sort') {
      facetsEle = this.querySelector('.facets__sort');
      otherFacetsEle = this.querySelector('.facets__filters');
    } else {
      facetsEle = this.querySelector('.facets__filters');
      otherFacetsEle = this.querySelector('.facets__sort');
    };

    if (event.currentTarget.getAttribute('aria-expanded') == 'false') {
      facetsEle.classList.add('open');
      otherFacetsEle.classList.remove('open');
      event.currentTarget.setAttribute('aria-expanded', 'true');
      this.closest('facets-drawer').querySelector(`.facets__mobile-nav-item[data-id="${otherFacetsEle.id}"]`).setAttribute('aria-expanded', 'false');
    } else {
      facetsEle.classList.remove('open');
      event.currentTarget.setAttribute('aria-expanded', 'false');
    }
  }
}

customElements.define('facets-drawer', FacetsDrawer);
